module.exports = __webpack_public_path__ + "img/download_btn.9a859606.png";